import { useState } from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navbar({ links }) {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" onClick={() => setOpen(false)}>
          <img src="/logo192.png" alt="10 Thirty" className="navbar-logo" />
          <span>10 Thirty</span>
        </Link>

        {/* Desktop links */}
        <div className="navbar-links">
          {links.map((link) =>
            link.external ? (
              <a
                key={link.label}
                href={link.to}
                className={link.cta ? 'navbar-cta' : undefined}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.to}
                className={link.cta ? 'navbar-cta' : undefined}
              >
                {link.label}
              </Link>
            )
          )}
          <LanguageSwitcher />
        </div>

        {/* Hamburger button (mobile only) */}
        <button
          className="navbar-hamburger"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
        >
          <span className={`hamburger-bar ${open ? 'open' : ''}`} />
          <span className={`hamburger-bar ${open ? 'open' : ''}`} />
          <span className={`hamburger-bar ${open ? 'open' : ''}`} />
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="navbar-mobile">
          {links.map((link) =>
            link.external ? (
              <a
                key={link.label}
                href={link.to}
                className={link.cta ? 'navbar-mobile-cta' : 'navbar-mobile-link'}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.to}
                className={link.cta ? 'navbar-mobile-cta' : 'navbar-mobile-link'}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </Link>
            )
          )}
          <LanguageSwitcher className="navbar-mobile-language" />
        </div>
      )}
    </nav>
  );
}
